var _ellipse, _rect, _rect2, _ellipse2, _ellipse3, _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 107,
    viewBox: "0 0 141 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.3501,
    cy: 63.885,
    rx: 44.177,
    ry: 41.4159,
    fill: "#24C2F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.3501,
    y: 20.6901,
    width: 26.7996,
    height: 19.3274,
    rx: 2,
    transform: "rotate(-30.018 44.3501 20.6901)",
    fill: "#24C2F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.136,
    y: 0.380554,
    width: 26.7996,
    height: 19.3274,
    rx: 2,
    transform: "rotate(52.5921 43.136 0.380554)",
    fill: "#24C2F3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.8103,
    cy: 50.0797,
    rx: 2.0708,
    ry: 2.76106,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8545,
    cy: 51.4602,
    rx: 2.0708,
    ry: 2.76106,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_142_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6372 62.3123L115.045 61.4709C123.43 61.3005 130.365 67.9598 130.536 76.345C130.706 84.7302 124.047 91.6659 115.662 91.8363L100.143 92.1517C85.8449 92.4422 74.0188 81.0871 73.7282 66.7893L73.6372 62.3123Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_142_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4387 62.8691L93.2325 31.288C98.6584 24.8926 108.241 24.1067 114.637 29.5326C121.032 34.9585 121.818 44.5414 116.392 50.9368L106.35 62.773C97.0983 73.6778 80.7581 75.0179 69.8533 65.7661L66.4387 62.8691Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.304 63.5352C12.7347 63.7075 12.4098 64.3099 12.6159 64.8678C13.3062 66.7368 14.3038 68.4802 15.5699 70.0251C17.0637 71.848 18.902 73.3589 20.9797 74.4713C23.0575 75.5838 25.334 76.2761 27.6793 76.5088C30.0246 76.7415 32.3928 76.51 34.6486 75.8274C36.9044 75.1449 39.0037 74.0247 40.8266 72.5308C42.6495 71.037 44.1604 69.1987 45.2728 67.121C46.3853 65.0432 47.0777 62.7667 47.3103 60.4214C47.5075 58.4338 47.3713 56.4297 46.9097 54.4915C46.7719 53.913 46.1675 53.5917 45.5982 53.7639C45.029 53.9362 44.711 54.5367 44.8441 55.1163C45.2266 56.7827 45.3365 58.5026 45.1672 60.2088C44.9625 62.2727 44.3532 64.276 43.3742 66.1044C42.3953 67.9328 41.0657 69.5505 39.4616 70.8651C37.8574 72.1797 36.01 73.1654 34.0249 73.7661C32.0398 74.3667 29.9558 74.5705 27.8919 74.3657C25.828 74.161 23.8247 73.5517 21.9963 72.5727C20.1679 71.5937 18.5502 70.2642 17.2356 68.6601C16.1489 67.3339 15.2869 65.8416 14.6814 64.2427C14.4707 63.6865 13.8732 63.363 13.304 63.5352Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_142_174",
    x: 63.6372,
    y: 55.4677,
    width: 76.9019,
    height: 50.6895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_142_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_142_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_142_174",
    x: 56.4387,
    y: 19.9262,
    width: 73.5598,
    height: 65.9892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_142_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_142_174",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLevel3);
export default __webpack_public_path__ + "static/media/UserLevel3.be7f7e4b21dd13230f8e07db5c619d08.svg";
export { ForwardRef as ReactComponent };